import React, { useState } from 'react';
import {
  FilterColorsType,
  FiltersContextType,
} from './types/FiltersContextType';
import {
  FILTER_MAX_GARMENTS_COUNT,
  FILTER_MIN_GARMENTS_COUNT,
} from '../constants/StylistConstants';

export const FiltersContext = React.createContext<FiltersContextType | null>(
  null,
);

type FiltersProviderProps = {
  children: React.ReactNode;
};

const FiltersProvider: React.FC<FiltersProviderProps> = ({ children }) => {
  const [filterGarmentsIds, setFilterGarmentsIds] = useState<string[]>([]);
  const [filterColors, setFilterColors] = useState<FilterColorsType[]>([]);
  const [filterGarmentsCount, setFilterGarmentsCount] = useState([
    FILTER_MIN_GARMENTS_COUNT,
    FILTER_MAX_GARMENTS_COUNT,
  ]);
  const [showFilters, setShowFilters] = useState(false);
  const clearFilterGarments = () => {
    setFilterGarmentsIds([]);
  };
  const appendFilterGarmentIds = (garmentId: string) => {
    if (filterGarmentsIds.indexOf(garmentId) === -1) {
      let garmentIds: string[] = [];
      filterGarmentsIds.map((garId) => garmentIds.push(garId));
      garmentIds.push(garmentId);
      setFilterGarmentsIds(garmentIds);
    }
  };
  const saveShowFilters = (show: boolean) => {
    setShowFilters(show);
  };
  const saveFilterColors = (colors: FilterColorsType[]) => {
    setFilterColors(colors);
  };
  const saveGarmentsCount = (counts: number[]) => {
    setFilterGarmentsCount(counts);
  };
  return (
    <FiltersContext.Provider
      value={{
        filterGarmentsIds,
        filterColors,
        filterGarmentsCount,
        showFilters,
        clearFilterGarments,
        appendFilterGarmentIds,
        saveFilterColors,
        saveGarmentsCount,
        saveShowFilters,
      }}
    >
      {children}
    </FiltersContext.Provider>
  );
};

export default FiltersProvider;
